<template lang='pug'>
  footer.Footer
    .container.py-5
      .row
        .col-12.col-md.Footer-block
          h5.Footer-headline Christoph Schommer
          small.d-block.mb-3.text-muted &copy; {{year}}
        .col-12.col-md.Footer-block
          h5.Footer-headline Kontakt
          .text-small
            p.Footer-item
              | Albestraße 21, 12159 Berlin
              br
              | Tel: 030 / 74 75 10-10
              br
              | Fax: 030 / 74 75 10-44
              br
              | Mail: schommer@bln-partner.de
        .col-12.col-md.Footer-block
          h5.Footer-headline Ressourcen
          ul.text-small.Footer-list
            li
              router-link.Footer-item( :to="{ name: 'Impressum' }" tag='a' ) Impressum
            li
              router-link.Footer-item( :to="{ name: 'Datenschutz' }" tag='a' ) Datenschutz
            li
              router-link.Footer-item( :to="{ name: 'Haftungsausschluss' }" tag='a' ) Haftungsausschluss              
</template>

<script>
  export default {
    data () {
      return {
        year: new Date().getFullYear()
      }
    }
  }
</script>

<style lang='stylus' scoped>
  .Footer {
    margin-top 3em

    box-shadow 0px 1px 5px #222
    background-color $primary

    +below('m') {
      margin-top 1em
    }

    &-block {
      color $primary-text

      +below('m') {
        margin-bottom 1em
      }
    }

    &-headline {
      font-weight bold
      color $tertiary--light
    }

    &-list {
      display flex
      flex-direction column
      list-style none
    }

    &-item {
      color $primary-text
      font-size 14px

      &:hover {
        color $primary-text
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/page/Footer.vue